export default __webpack_public_path__ + "static/media/cat_waterEnOfRecreatieschap.3568aa0b.svg";